//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { AfterEventCancellationDeadlineAction, CancellationConversionPolicy, BeforeEventCancellationDeadlineAction } from './Enums';

export class SchoolEventPolicyCancellationDeadlineSettingsUpdateItem extends ItemBase {
    AfterCancellationDeadlineAction?: AfterEventCancellationDeadlineAction;
    AfterCancellationDeadlineConvertAction?: CancellationConversionPolicy;
    BeforeCancellationDeadlineAction?: BeforeEventCancellationDeadlineAction;
    BeforeCancellationDeadlineConvertAction?: CancellationConversionPolicy;
    CreateNotification?: boolean;
    HoursUntilDeadline?: number;

    constructor(initializer?: Partial<SchoolEventPolicyCancellationDeadlineSettingsUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SchoolEventPolicyCancellationDeadlineSettingsUpdateItem";
}
